/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable import/prefer-default-export */
import {
    // unitBase,
    rowSpacing,
    // fontSizeDesktop,
    // fontSize,
    enterpriseCSS,
    // paletteHD,
} from './variables';

// eslint-disable-next-line arrow-body-style
export const DesktopAddressBookStyle = (typography, palette) => {
    return {
        DesktopAddressBookStyle: {

            '& .addNewAddressWrapper': {
                padding: `${rowSpacing * 2}px 0`,
                display: 'inline-table',
                borderTop: `1px solid ${palette.grey7}`,
                borderRight: `1px solid ${palette.grey7}`,
                width: '100%', // allign border right to the top element which is 1px off
                '&.empty': {
                    textAlign: 'center',
                    borderTop: 0,
                    borderRight: 0,
                    '& button': {
                        float: 'none !important',
                    },
                },
            },

            '& .emptyListWrapper': {
                width: '100%',
                height: '100%',
                paddingTop: rowSpacing * 2,
                borderRight: `1px solid ${palette.grey7}`,
            },

            '& .addressListWrapper': {
                width: '100%',
                position: 'relative',
                overflow: 'auto',
                height: '500px', // allign border bottom to the left element which is 1px off
                padding: `0 ${rowSpacing * 2}px`,
                borderRight: `1px solid ${palette.grey7}`,
            },

            '& .addressList': {
                marginTop: rowSpacing * 2, // 72px
                maxHeight: 'calc(500px - 92px)',
                overflow: 'auto',
            },

            '& .addressListItem': {
                borderBottom: `1px solid ${palette.grey7}`,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',

                '& .listRecipient': {
                    flex: 1,
                    display: 'inline-block',
                    fontWeight: 600,
                    padding: rowSpacing,
                },

                '& .svgIcon': {
                    float: 'right',
                    padding: '4px',
                    marginRight: '8px',
                    color: palette.grey7,
                },

                '&:hover, &.selected': {
                    backgroundColor: palette.grey7,

                    '& .svgIcon': {
                        color: palette.text.primary,
                    },
                },
            },

            '& .desktopSearch': {
                position: 'relative',
                '& svg': {
                    position: 'absolute',
                    top: '20px',
                    left: '8px',
                },
                '& .split > div ': {
                    marginRight: '0 !important',
                },
                '& .text-field-input': {
                    paddingLeft: '35px !important',
                },
            },

            // '& form': {
            //     display: 'flex',
            // },

            '& .addressDetailsWrapper': {
                display: 'flex',
                flexDirection: 'column',

                '& > form': {
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',

                    '& .buttonForm': {
                        paddingBottom: rowSpacing * 2,
                    },
                },

                '& .noAddressSelected': {
                    position: 'relative',
                    top: '40%',
                    textAlign: 'center',
                },

                '& .addressDetails': {
                    flex: 1,
                    padding: rowSpacing * 2,

                    '& .addressDetailsInner': {
                        // transform: 'translate(0, +50%)',
                        marginTop: rowSpacing * 8, // 96px

                        '& .label': {
                            flex: 1,
                            textAlign: 'right',
                            color: enterpriseCSS.palette.gray1,
                            paddingRight: rowSpacing,
                            padding: `${rowSpacing}px 0 ${rowSpacing - 4}px 0`,
                            '&.alignTop': {
                                alignSelf: 'start',
                            },
                            '& > span': {
                                display: 'block',
                                marginBottom: '4px',
                            },
                        },

                        '& .content': {
                            flex: 'none',
                            fontWeight: 700,
                            padding: `${rowSpacing}px 0 ${rowSpacing - 4}px 0`,
                            minWidth: '55%',
                            '& > span': {
                                display: 'block',
                                marginBottom: '4px',
                            },
                        },
                    },

                    '& .rightSide': {
                        width: '50%',
                        textAlign: 'left',
                        display: 'inline-block',
                        '& span': {
                            display: 'block',
                            fontWeight: 700,
                            padding: '10px 0',
                        },
                    },

                    '& .leftSide': {
                        width: '48%',
                        display: 'inline-block',
                        textAlign: 'right',
                        paddingRight: '15px',
                        '& span': {
                            display: 'block',
                            padding: '10px 0',
                            color: enterpriseCSS.palette.gray1,
                        },
                    },
                },

                '& .editButton': {
                    padding: `${rowSpacing * 2}px 0`,
                    borderTop: `1px solid ${palette.grey7}`,
                    display: 'inline-block',
                    width: '100%',
                    flex: 'none',
                    '& > button': {
                        width: '150px',
                        float: 'right',
                        backgroundColor: '#4891DE', // TO DO
                        color: palette.white,
                        marginRight: '24px',
                        '&:hover': {
                            backgroundColor: '#4891DE', // TO DO
                            color: palette.white,
                        },
                    },
                },

                '& .address-verify': {
                    marginTop: rowSpacing * 2,
                    height: '100%',
                    position: 'relative',

                    '& .select-field-wrapper': {
                        '& .select-wrapper': {
                            border: '1px solid #2f2f2f',

                            '&::before': {
                                display: 'none',
                            },

                            '& svg': {
                                top: 'calc(50% - 14px)',
                            },
                        },
                    },
                    '& .addressVerifyWrapper': {
                        textAlign: 'center',
                        margin: `${rowSpacing * 2}px 0`,

                        '& button': {
                            float: 'none',
                            width: 'auto',
                        },
                    },
                    '& .buttons-wrapper': {
                        bottom: rowSpacing * 2,
                        paddingTop: rowSpacing * 2,
                        borderTop: `1px solid ${palette.grey7}`,
                    },
                },
            },

            '& .addressFormDesktop': {
                margin: `${rowSpacing * 2}px auto`,
                maxWidth: 430,
                width: '100%',
                '& .desktop-helper-text': {
                    marginTop: '2px !important',
                    fontSize: '11px !important',
                },

                '& .suggested-address': {
                    width: rowSpacing * 28,
                    top: '1px',
                },
            },

            '& .buttonCancel, & .buttonDelete': {
                backgroundColor: `${enterpriseCSS.palette.white} !important`,
                color: '#4891DE !important', // TO DO
            },
        },
    };
};
